import { render, staticRenderFns } from "./ModalInfoVatShop.vue?vue&type=template&id=64de1450"
import script from "./ModalInfoVatShop.vue?vue&type=script&lang=js"
export * from "./ModalInfoVatShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports